import _ from "lodash";

const getActor = actor => _.get(actor, "email", _.get(actor, "user.email"));

export default getActor;
